import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import axios from 'axios'

Vue.use(Vuex)
// Vue.config.devtools = true // enables devtools in production mode

// Initialise vuex store persistence into localStorage, so that data persists between refresh
const vuexLocal = new VuexPersistence({
  storage: window.localStorage,

  // Don't persist these state variables
  reducer: state =>
    Object.keys(state).reduce((acc, curr) => {
      if (!['dialog', 'loadingDialog', 'loginErrorMsg'].includes(curr)) acc[curr] = state[curr]
      return acc
    }, {})
})

let store = new Vuex.Store({
  state: {
    // User state
    status: '',
    token: '',
    schoolId: 0,
    Dbasename: '',
    userId: 0,
    pupilId: 0,
    parentName: '',
    schoolName: '',

    // Pupil
    pupilsArr: [],

    // App state
    // appColour: '#ffa500',
    appColour: '#00B0B9',
    darkToolbar: false,
    loginErrorMsg: '',
    dialog: false,
    loadingDialog: false,
    unreadCounts: {},
    appleSubscriptionToken: '',
    menuConfig: {},
    currentDialogTitle: '',
    isAppleSubscribed: false,
    logresponse: false,
    trueUser: 0,
    withPin: false,
    // reminderAlertMsg: true,
    // userExpiry: ''
    // reminderAlertMsg: true,
    // userExpiry: ''
    socket: null,
    socketState: WebSocket.CLOSED,
    onlineTeachers: {},
    selectedTeacher: null,
    teachers: [],
    teacherMessages: {},
    caregiverMessages: {}
  },

  mutations: {
    auth_request (state) {
      state.status = 'loading'
    },
    auth_success (state, payload) {
      state.status = 'success'
      state.token = payload.token
      state.userId = payload.userId
      state.pupilId = payload.pupilId
      state.Dbasename = payload.Dbasename
      state.schoolId = payload.schoolId
      state.parentName = payload.parentName
      state.schoolName = payload.schoolName
      state.appColour = payload.appColour
      state.darkToolbar = payload.darkToolbar
      state.trueUser = payload.userId
    },
    auth_error (state) {
      state.status = 'error'
    },
    clear_auth_error (state) {
      state.status = ''
      state.loginErrorMsg = ''
    },
    logout (state) {
      // state.status = ''
      state.token = ''
      state.schoolId = 0
      state.Dbasename = ''
      state.userId = 0
      state.pupilId = 0
      state.parentName = ''
      state.loadingDialog = false
      state.pupilsArr = []
      state.schoolName = ''
      // state.appColour = '#ffa500'
      state.appColour = '#00B0B9'
      state.darkToolbar = false
      state.unreadCounts = {}
      state.menuConfig = {}
      state.currentDialogTitle = ''
      state.trueUser = 0
      state.reminderAlertMsg = false
      state.withPin = false
      // state.userExpiry = ''
    },
    changePupil (state, newPupilId) {
      const pupil = state.pupilsArr.find(pupil => pupil.id === newPupilId)

      if (pupil) {
        state.pupilId = newPupilId
        state.parentName = pupil.PerferredName + ' ' + pupil.PerferredSname
        state.Dbasename = pupil.Dbasename
        state.schoolId = pupil.schoolId
        state.schoolName = pupil.schoolName
        state.darkToolbar = pupil.darkToolbar
        state.trueUser = pupil.otherSchoolCaregiverID
        state.userId = pupil.otherSchoolCaregiverID
      }
    },
    reset_status (state) {
      state.status = ''
    },
    error_message (state, newErrorMsg) {
      state.loginErrorMsg = newErrorMsg
    },
    toggle_dialog (state, toggleStatus) {
      if (typeof toggleStatus !== 'undefined') {
        state.dialog = toggleStatus
      } else {
        state.dialog = !state.dialog
      }
      // if (state.dialog) {
      //   document.getElementsByTagName('body')[0].className = 'noscroll'
      // } else {
      //   document.body.removeAttribute('class', 'noscroll')
      // }
    },
    loading (state, loadingStatus) {
      state.loadingDialog = loadingStatus
    },
    update_unread_counts (state, newUnreadCounts) {
      state.unreadCounts = newUnreadCounts
    },

    clear_unread_notices (state) {
      state.unreadCounts['Notices'] = {}
      state.unreadCounts['School Notices'] = {}
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage('clearNotificationBadge')
      }
    },
    clear_unread_messages (state) {
      state.unreadCounts['Messages'] = {}
      state.unreadCounts['Teacher Messages'] = {}
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage('clearNotificationBadge')
      }
    },
    clear_unread_permission_slips (state) {
      state.unreadCounts['Permission Slips'] = {}
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage('clearNotificationBadge')
      }
    },
    increment_unread_badge (state, menuItems) {
      if (!Array.isArray(menuItems) && typeof menuItems === 'string') {
        menuItems = [menuItems]
      }

      menuItems.forEach(menuItem => {
        if (typeof state.unreadCounts[menuItem] === 'undefined') {
          Vue.set(state.unreadCounts, menuItem, { count: 1 })
        } else {
          state.unreadCounts[menuItem].count++
        }
      })
    },
    update_apple_subscription_token (state, newToken) {
      state.appleSubscriptionToken = newToken
      if (newToken !== '') {
        state.isAppleSubscribed = true
      } else {
        state.isAppleSubscribed = false
      }
    },
    update_subscription_status (state, newStatus) {
      state.isAppleSubscribed = newStatus
    },

    update_pupils_array (state, newPupilsArr) {
      state.pupilsArr = newPupilsArr
    },
    add_menu_config_item (state, payload) {
      Vue.set(state.menuConfig, payload.name, payload.menuItemObj)
      Vue.set(state.menuConfig[payload.name], 'order', payload.order)
      Vue.set(state.menuConfig[payload.name], 'menuItem', payload.name)
    },
    clear_menu_config (state) {
      state.menuConfig = {}
    },
    set_dialog_title (state, newDialogTitle) {
      state.currentDialogTitle = newDialogTitle
      if (typeof state.unreadCounts[newDialogTitle] !== 'undefined') {
        state.unreadCounts[newDialogTitle].count = 0
      }
    },
    log_response (state, newLog) {
      state.logresponse = newLog
    },
    new_user_id (state, newUserId) {
      state.trueUser = newUserId
    },
    reminder_alert (state, reminderStatus) {
      state.reminderAlertMsg = reminderStatus
    },
    showExpiry (state, expiryDate) {
      state.userExpiry = expiryDate
    },
    withPin (state, pinStatus) {
      state.withPin = pinStatus
    },
    setSocketState (state, newState) {
      state.socketState = newState
    },
    setSocket (state, socket) {
      state.socket = socket
    },
    setOnlineTeacherStatus (state, { teacherID, online }) {
      Vue.set(state.onlineTeachers, teacherID, online)
    },
    selectTeacher (state, teacher) {
      state.selectedTeacher = teacher
    }
    // addTeacherMessage (state, { teacherId, message }) {
    //   if (!state.teacherMessages[teacherId]) {
    //     Vue.set(state.teacherMessages, teacherId, [])
    //   }
    //   state.teacherMessages[teacherId].push(message)
    // },
    // addCaregiverMessage (state, { caregiverId, message }) {
    //   if (!state.caregiverMessages[caregiverId]) {
    //     Vue.set(state.caregiverMessages, caregiverId, [])
    //   }
    //   state.caregiverMessages[caregiverId].push(message)
    // }
  },
  actions: {
    login ({ dispatch, commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios({ url: 'https://www.atschool.co.nz/api/v2/login', data: user, method: 'POST' })
          .then(resp => {
            const data = {
              token: resp.data.token,
              userId: resp.data.parent_id,
              parentName: resp.data.parent_name,
              pupilId: resp.data.pupil_id,
              Dbasename: resp.data.dbasename,
              schoolId: resp.data.school_id,
              schoolName: resp.data.school_name,
              appColour: resp.data.app_colour,
              darkToolbar: resp.data.use_dark_toolbar,
              loginId: user.userId
            }
            return dispatch('updateLoginState', data)
          })
          .then(() => resolve())
          .catch(err => {
            commit('auth_error')
            reject(err)
          })
      })
    },

    tokenLogin ({ dispatch, commit }, token) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
        axios({ url: 'https://www.atschool.co.nz/api/v2/getLoginInfo', method: 'GET' })
          .then(resp => {
            const data = {
              token: token,
              userId: resp.data.parent_id,
              parentName: resp.data.parent_name,
              pupilId: resp.data.pupil_id,
              Dbasename: resp.data.dbasename,
              schoolId: resp.data.school_id,
              schoolName: resp.data.school_name,
              appColour: resp.data.app_colour,
              darkToolbar: resp.data.use_dark_toolbar,
              loginId: resp.data.school_id + '/' + resp.data.pupil_id + '/' + resp.data.parent_id,
              disablePin: resp.data.disable_pin
            }
            return dispatch('updateLoginState', data)
          })
          .then(() => resolve())
          .catch(err => {
            commit('auth_error')
            reject(err)
          })
      })
    },

    updateLoginState ({ commit }, data) { // update login state after successful login
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.token

        document.title = data.schoolName
        localStorage.setItem('loginId', data.loginId) // For save login id when log out
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage('appColour ' + data.appColour)
        }

        if (data.disablePin && data.disablePin === true) {
          commit('withPin', null)
        }

        commit('auth_success', {
          token: data.token,
          userId: data.userId,
          Dbasename: data.Dbasename,
          schoolId: data.schoolId,
          pupilId: data.pupilId,
          parentName: data.parentName,
          schoolName: data.schoolName,
          appColour: data.appColour,
          darkToolbar: data.darkToolbar
        })
        resolve()
      })
    },

    logout ({ commit }) {
      return new Promise((resolve, reject) => {
        commit('logout')
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage('appColour #00B0B9')
        }
        delete axios.defaults.headers.common['Authorization']
        document.title = '@school'

        // Unsubscribe only if not on iOS as push is not supported on iOS
        // No need to unsubscribe as users should still get notifications even if logged out, they can unsubscribe in the app if they no longer wish to receive them
        // var userAgent = window.navigator.userAgent
        // if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
        //   // console.log('iOS detected')
        // } else if (process.env.NODE_ENV === 'production' && window.PushManager) {
        //   window.pushHelper.unsubscribe()
        // }
        resolve()
      })
    },

    logReadItems ({ commit, state }) {
      let unreadIds = (typeof state.unreadCounts[state.currentDialogTitle] !== 'undefined') ? state.unreadCounts[state.currentDialogTitle].unread_ids : []
      if (unreadIds.length !== 0) {
        axios.post('https://www.atschool.co.nz/api/v2/logReadItemsV2/' + state.Dbasename, {
          menuItem: state.currentDialogTitle,
          caregiverId: state.userId,
          pupilId: state.pupilId,
          idsToLog: unreadIds
        })
      }
    },

    checkUnreadCounts ({ commit, state }) {
      axios.get('https://www.atschool.co.nz/api/v2/caregiversV2/' + state.Dbasename + '/' + state.userId + '/pupilsV2/' + state.pupilId + '/unreadV2')
        .then(resp => {
          commit('update_unread_counts', resp.data)

          if (window.ReactNativeWebView) {
            let totalUnreadCounts = 0
            Object.keys(resp.data).forEach(function (item) {
              totalUnreadCounts += resp.data[item].count
            })
            window.ReactNativeWebView.postMessage('setBadge ' + totalUnreadCounts)
          }
        })
    },

    updateATSchoolLog ({ commit, state }) {
      axios.get('https://www.atschool.co.nz/api/v2/caregiversV2/' + state.Dbasename + '/' + state.userId + '/pupilsV2/' + state.pupilId + '/updateLogV2')
        .then(resp => {
          commit('log_response', resp.data)
          if (resp.data === 'Success') {
            axios.get('https://www.atschool.co.nz/api/v2/caregiversV2/' + state.Dbasename + '/' + state.userId + '/pupilsV2/' + state.pupilId + '/caregiverPermissionIdV2')
              .then(resp => {
                commit('new_user_id', resp.data)
              })
          }
        })
    },
    async fetchPin ({ commit, state }, userId) {
      try {
        const resp = await axios.post('withPinCodeV2/' + state.Dbasename, { userId })
        const result = resp.data.success === true
        commit('withPin', result)
      } catch (error) {
        console.error('Error:', error)
        commit('withPin', false)
      }
    },
    startWebSocket ({ commit, state }, { clientName }) {
      if (!state.socket || state.socket.readyState !== WebSocket.OPEN) {
        const socket = new WebSocket(`wss://chat.etap.co.nz:9509?client=${clientName}`)
        // const socket = new WebSocket(`ws://edit2.etap.co.nz:9509?client=${clientName}`)
        socket.addEventListener('open', (event) => {
          commit('setSocket', socket)
          commit('setSocketState', socket.readyState)
          console.log('WebSocket connection opened')
        })

        socket.addEventListener('message', (event) => {
          const data = JSON.parse(event.data)

          // try {
          //   commit('addTeacherMessage', { teacherId: data.senderID, message: data })
          // } catch (error) {
          // }
          // Handle incoming messages
          if (data.type === 'teacher_status') {
            commit('setOnlineTeacherStatus', { teacherID: data.teacherID, online: data.online })
          }
          // store the messages for app. teachers
        })

        socket.addEventListener('error', (event) => {
          console.log('WebSocket Error:', event)
          // Handle errors
        })

        socket.addEventListener('close', (event) => {
          console.log(`WebSocket closed, code=${event.code}, reason=${event.reason}`)
          commit('setSocket', null)
          commit('setSocketState', WebSocket.CLOSED)
        })

        commit('setSocket', socket)
        commit('setSocketState', socket.readyState)
      }
    },

    sendMessage ({ state }, messageData) {
      if (state.socketState === WebSocket.OPEN) {
        state.socket.send(JSON.stringify(messageData))
      } else {
        console.error('WebSocket connection is not open.')
      }
    }
  },

  getters: {
    isLoggedIn: state => !!state.token,

    pupilIndex: state => {
      return state.pupilsArr.findIndex(x => x.id === parseInt(state.pupilId))
    },
    pupilPhoto: (state, getters) => {
      if (state.pupilsArr.length !== 0) {
        return state.pupilsArr[getters.pupilIndex].photo
      } else {
        return ''
      }
    },
    pupilFullName: (state, getters) => {
      if (state.pupilsArr.length !== 0) {
        return state.pupilsArr[getters.pupilIndex].PerferredName + ' ' + state.pupilsArr[getters.pupilIndex].PerferredSname
      } else {
        return ''
      }
    },
    pupilPreferredName: (state, getters) => {
      if (state.pupilsArr.length !== 0) {
        return state.pupilsArr[getters.pupilIndex].PerferredName
      } else {
        return ''
      }
    },
    pupilRoom: (state, getters) => {
      if (state.pupilsArr.length !== 0) {
        return state.pupilsArr[getters.pupilIndex].Room
      } else {
        return ''
      }
    },
    pupilForm: (state, getters) => {
      if (state.pupilsArr.length !== 0) {
        return state.pupilsArr[getters.pupilIndex].Form
      } else {
        return ''
      }
    }
  },

  plugins: [vuexLocal.plugin]
})

export default store
